<template>
  <div class="card-block">
    <div v-if="$slots['header'] || $slots['title']" class="card-block__header">
      <button
        class="card-block__title"
        type="button"
        @click.prevent="emit('click:title', $event)"
      >
        <slot name="title"></slot>
      </button>
      <slot name="header"></slot>

      <div v-if="$slots['actions']" class="card-block__actions">
        <slot name="actions"></slot>
      </div>
    </div>
    <div v-if="$slots['default']" class="card-block__body">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "CardBlock"
});

const emit = defineEmits<{
  (e: "click:title", event: MouseEvent): void;
}>();
</script>

<style lang="scss">
.card-block {
  // background-color: rgba(var(--tint-contrast), 0.01);
  font-size: 13px;

  // border-top: 2px solid var(--color-border);
  // border-bottom: 2px solid var(--color-border);
  border-left: 2px solid var(--color-border);
  // border-right: 2px solid var(--color-border);

  box-shadow: 0 1px 0.25rem var(--color-shadow-1);

  border-radius: 5px;

  &__header {
    display: grid;
    grid-template-columns: minmax(0, 1fr) max-content;
    gap: 0.5rem;
    background-color: var(--color-background-shallow);
    padding: 0;
    border-bottom: 1px solid var(--color-border-light);
  }

  &__title {
    font-size: 14px;
    font-weight: 500;
    margin: 0;
    line-height: 1.2;
    color: var(--color-text-medium);
    padding: 0.5rem 0;
    padding-left: 1rem;
    text-align: left;
    border: none;
    background: none;

    &:hover {
      color: var(--color-text);
    }
    &:active {
      color: var(--color-action);
    }
  }

  &__actions {
    font-size: 16px;
    // padding: 0.25rem;
    padding-right: 0.75rem;
    display: flex;
  }
  &__icon {
    font-size: 16px;
    padding: 0.25rem;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.75rem 1rem;
  }
}
</style>
